<div class="mat">
  <ng-container *ngIf="isSuperAdmin; else treeBody">
    <div class="mat__superadmin flex align-items-center gap-2">
      <span class="pi pi-shield mat__superadmin-icon"></span>
      <span>Super Admin has unrestricted access to every module, scope and permission.</span>
    </div>
  </ng-container>

  <ng-template #treeBody>
    <!-- Master: All Modules -->
    <div class="mat__master flex align-items-center gap-2">
      <app-primeng-checkbox
        [value]="allGranted"
        [indeterminate]="!allGranted && groups.some(g => groupPartial(g))"
        (valueChange)="onAllGrantedChange($event)"
      ></app-primeng-checkbox>
      <div class="flex-1 flex align-items-center justify-content-between gap-2">
        <span class="mat__master-label">All Modules</span>
        <div class="flex align-items-center gap-2">
          <span class="mat__muted">Permission:</span>
          <app-primeng-select
            [value]="allPermission"
            [options]="permissionOptions"
            optionLabel="label"
            optionValue="value"
            [styleClass]="'mat__perm-select'"
            (valueChange)="onAllPermissionChange($event)"
          ></app-primeng-select>
        </div>
      </div>
    </div>

    <!-- Groups -->
    <ng-container *ngFor="let group of groups">
      <div
        class="mat__group flex align-items-center gap-2"
        [class.mat__group--open]="isGroupExpanded(group.key)"
      >
        <app-primeng-checkbox
          [value]="groupGranted(group)"
          [indeterminate]="groupPartial(group)"
          (valueChange)="toggleGroupAll(group)"
        ></app-primeng-checkbox>
        <span
          class="pi pi-chevron-right mat__chevron"
          [class.mat__chevron--open]="isGroupExpanded(group.key)"
          (click)="toggleGroup(group.key)"
        ></span>
        <span class="pi mat__group-icon" [class]="group.icon"></span>
        <span class="mat__group-label">{{ group.label }}</span>
        <span class="mat__count">{{ groupGrantedCount(group) }}/{{ group.modules.length }}</span>
        <span class="flex-1"></span>
      </div>

      <div class="mat__modules" *ngIf="isGroupExpanded(group.key)">
        <ng-container *ngFor="let mod of group.modules">
          <div
            class="mat__node flex align-items-center gap-2"
            [class.mat__node--granted]="isGranted(mod.id)"
            [class.mat__node--revoked]="!isGranted(mod.id)"
          >
            <app-primeng-checkbox
              [value]="isGranted(mod.id)"
              (valueChange)="onToggleGrant(mod.id)"
            ></app-primeng-checkbox>
            <span
              class="pi mat__node-icon"
              [class]="mod.icon"
              [style.color]="isGranted(mod.id) ? mod.color : '#9e9e9e'"
            ></span>
            <span class="mat__node-label flex-1">{{ mod.label }}</span>

            <span class="mat__scope-pill" (click)="toggleScope(mod.id)">
              <span class="mat__muted">Scope:</span>
              <span class="mat__scope-text">{{ scopeSummary(mod.id) }}</span>
              <span
                class="pi pi-chevron-down mat__chevron"
                [class.mat__chevron--open]="isScopeExpanded(mod.id)"
              ></span>
            </span>

            <app-primeng-select
              [value]="permission(mod.id)"
              [options]="permissionOptions"
              optionLabel="label"
              optionValue="value"
              [styleClass]="'mat__perm-select'"
              (valueChange)="onPermissionChange(mod.id, $event)"
            ></app-primeng-select>
          </div>

          <!-- Scope editor -->
          <div class="mat__scope" *ngIf="isScopeExpanded(mod.id)">
            <div class="mat__scope-row flex align-items-center flex-wrap gap-2">
              <span class="mat__muted">Level:</span>
              <ng-container *ngFor="let lvl of scopeLevels">
                <span
                  class="mat__lvl"
                  [class.mat__lvl--active]="scopeLevel(mod.id) === lvl.value"
                  (click)="onScopeLevelChange(mod.id, lvl.value)"
                >
                  <span class="pi" [class]="lvl.icon"></span> {{ lvl.label }}
                </span>
              </ng-container>
            </div>

            <div class="mat__scope-row flex align-items-center flex-wrap gap-2" *ngIf="scopeLevel(mod.id) === 'region'">
              <span class="mat__muted">Regions:</span>
              <span
                class="mat__chip"
                *ngFor="let r of regions"
                [class.mat__chip--on]="scopeRegions(mod.id).includes(r)"
                (click)="onToggleRegion(mod.id, r)"
              >{{ r }}</span>
            </div>

            <div class="mat__scope-row flex align-items-center flex-wrap gap-2" *ngIf="scopeLevel(mod.id) === 'country'">
              <span class="mat__muted">Countries:</span>
              <span
                class="mat__chip"
                *ngFor="let c of countries"
                [class.mat__chip--on]="scopeCountries(mod.id).includes(c)"
                (click)="onToggleCountry(mod.id, c)"
              >{{ c }}</span>
            </div>

            <div class="mat__scope-row flex align-items-center flex-wrap gap-2" *ngIf="scopeLevel(mod.id) === 'company'">
              <span class="mat__muted">Companies:</span>
              <span
                class="mat__chip"
                *ngFor="let co of companies"
                [class.mat__chip--on]="scopeCompanies(mod.id).includes(co)"
                (click)="onToggleCompany(mod.id, co)"
              >{{ co }}</span>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-template>
</div>
